// CANONICAL COPY (GH #7115). src/constants/frameworks/iso27002.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

const FRAMEWORK_ISO27002 = {
  id: 'fw-iso27002',
  type: 'standard',
  name: 'ISO 27002:2022',
  shortName: 'ISO 27002',
  abbrev: 'I27k2',
  description:
    'Information security controls — 93 controls across 4 themes: Organizational (A.5), People (A.6), Physical (A.7) and Technological (A.8)',
  color: '#5eead4',
  version: '2022',
  sectionKeyDepth: 2,
  sections: [
    { key: 'A.5', name: 'Organizational controls' },
    { key: 'A.6', name: 'People controls' },
    { key: 'A.7', name: 'Physical controls' },
    { key: 'A.8', name: 'Technological controls' },
  ],
  mappings: [
    { externalId: 'A.5.1', scfId: 'SCF-GOV-001', ref: 'A.5.1' },
    { externalId: 'A.5.2', scfId: 'SCF-GOV-002', ref: 'A.5.2' },
    { externalId: 'A.5.3', scfId: 'SCF-GOV-003', ref: 'A.5.3' },
    { externalId: 'A.5.4', scfId: 'SCF-GOV-004', ref: 'A.5.4' },
    { externalId: 'A.5.5', scfId: 'SCF-GOV-005', ref: 'A.5.5' },
    { externalId: 'A.5.6', scfId: 'SCF-GOV-006', ref: 'A.5.6' },
    { externalId: 'A.5.7', scfId: 'SCF-GOV-007', ref: 'A.5.7' },
    { externalId: 'A.5.8', scfId: 'SCF-GOV-008', ref: 'A.5.8' },
    { externalId: 'A.5.9', scfId: 'SCF-AST-001', ref: 'A.5.9' },
    { externalId: 'A.5.10', scfId: 'SCF-AST-002', ref: 'A.5.10' },
    { externalId: 'A.5.11', scfId: 'SCF-AST-003', ref: 'A.5.11' },
    { externalId: 'A.5.12', scfId: 'SCF-AST-004', ref: 'A.5.12' },
    { externalId: 'A.5.13', scfId: 'SCF-AST-005', ref: 'A.5.13' },
    { externalId: 'A.5.14', scfId: 'SCF-AST-006', ref: 'A.5.14' },
    { externalId: 'A.5.15', scfId: 'SCF-IAM-001', ref: 'A.5.15' },
    { externalId: 'A.5.16', scfId: 'SCF-IAM-002', ref: 'A.5.16' },
    { externalId: 'A.5.17', scfId: 'SCF-IAM-003', ref: 'A.5.17' },
    { externalId: 'A.5.18', scfId: 'SCF-IAM-004', ref: 'A.5.18' },
    { externalId: 'A.5.19', scfId: 'SCF-VDR-001', ref: 'A.5.19' },
    { externalId: 'A.5.20', scfId: 'SCF-VDR-002', ref: 'A.5.20' },
    { externalId: 'A.5.21', scfId: 'SCF-VDR-003', ref: 'A.5.21' },
    { externalId: 'A.5.22', scfId: 'SCF-VDR-004', ref: 'A.5.22' },
    { externalId: 'A.5.23', scfId: 'SCF-VDR-005', ref: 'A.5.23' },
    { externalId: 'A.5.24', scfId: 'SCF-INC-001', ref: 'A.5.24' },
    { externalId: 'A.5.25', scfId: 'SCF-INC-002', ref: 'A.5.25' },
    { externalId: 'A.5.26', scfId: 'SCF-INC-003', ref: 'A.5.26' },
    { externalId: 'A.5.27', scfId: 'SCF-INC-004', ref: 'A.5.27' },
    { externalId: 'A.5.28', scfId: 'SCF-INC-005', ref: 'A.5.28' },
    { externalId: 'A.5.29', scfId: 'SCF-BCM-001', ref: 'A.5.29' },
    { externalId: 'A.5.30', scfId: 'SCF-BCM-002', ref: 'A.5.30' },
    { externalId: 'A.5.31', scfId: 'SCF-GOV-009', ref: 'A.5.31' },
    { externalId: 'A.5.32', scfId: 'SCF-GOV-010', ref: 'A.5.32' },
    { externalId: 'A.5.33', scfId: 'SCF-DAT-001', ref: 'A.5.33' },
    { externalId: 'A.5.34', scfId: 'SCF-DAT-002', ref: 'A.5.34' },
    { externalId: 'A.5.35', scfId: 'SCF-AUD-001', ref: 'A.5.35' },
    { externalId: 'A.5.36', scfId: 'SCF-AUD-002', ref: 'A.5.36' },
    { externalId: 'A.5.37', scfId: 'SCF-GOV-011', ref: 'A.5.37' },
    { externalId: 'A.6.1', scfId: 'SCF-PPL-001', ref: 'A.6.1' },
    { externalId: 'A.6.2', scfId: 'SCF-PPL-002', ref: 'A.6.2' },
    { externalId: 'A.6.3', scfId: 'SCF-PPL-003', ref: 'A.6.3' },
    { externalId: 'A.6.4', scfId: 'SCF-PPL-004', ref: 'A.6.4' },
    { externalId: 'A.6.5', scfId: 'SCF-PPL-005', ref: 'A.6.5' },
    { externalId: 'A.6.6', scfId: 'SCF-PPL-006', ref: 'A.6.6' },
    { externalId: 'A.6.7', scfId: 'SCF-PPL-007', ref: 'A.6.7' },
    { externalId: 'A.6.8', scfId: 'SCF-PPL-008', ref: 'A.6.8' },
    { externalId: 'A.7.1', scfId: 'SCF-PHY-001', ref: 'A.7.1' },
    { externalId: 'A.7.2', scfId: 'SCF-PHY-002', ref: 'A.7.2' },
    { externalId: 'A.7.3', scfId: 'SCF-PHY-003', ref: 'A.7.3' },
    { externalId: 'A.7.4', scfId: 'SCF-PHY-004', ref: 'A.7.4' },
    { externalId: 'A.7.5', scfId: 'SCF-PHY-005', ref: 'A.7.5' },
    { externalId: 'A.7.6', scfId: 'SCF-PHY-006', ref: 'A.7.6' },
    { externalId: 'A.7.7', scfId: 'SCF-PHY-007', ref: 'A.7.7' },
    { externalId: 'A.7.8', scfId: 'SCF-PHY-008', ref: 'A.7.8' },
    { externalId: 'A.7.9', scfId: 'SCF-PHY-009', ref: 'A.7.9' },
    { externalId: 'A.7.10', scfId: 'SCF-PHY-010', ref: 'A.7.10' },
    { externalId: 'A.7.11', scfId: 'SCF-PHY-011', ref: 'A.7.11' },
    { externalId: 'A.7.12', scfId: 'SCF-PHY-012', ref: 'A.7.12' },
    { externalId: 'A.7.13', scfId: 'SCF-PHY-013', ref: 'A.7.13' },
    { externalId: 'A.7.14', scfId: 'SCF-PHY-014', ref: 'A.7.14' },
    { externalId: 'A.8.1', scfId: 'SCF-OPS-001', ref: 'A.8.1' },
    { externalId: 'A.8.2', scfId: 'SCF-IAM-005', ref: 'A.8.2' },
    { externalId: 'A.8.3', scfId: 'SCF-IAM-006', ref: 'A.8.3' },
    { externalId: 'A.8.4', scfId: 'SCF-IAM-007', ref: 'A.8.4' },
    { externalId: 'A.8.5', scfId: 'SCF-IAM-008', ref: 'A.8.5' },
    { externalId: 'A.8.6', scfId: 'SCF-OPS-002', ref: 'A.8.6' },
    { externalId: 'A.8.7', scfId: 'SCF-OPS-003', ref: 'A.8.7' },
    { externalId: 'A.8.8', scfId: 'SCF-OPS-004', ref: 'A.8.8' },
    { externalId: 'A.8.9', scfId: 'SCF-OPS-005', ref: 'A.8.9' },
    { externalId: 'A.8.10', scfId: 'SCF-DAT-003', ref: 'A.8.10' },
    { externalId: 'A.8.11', scfId: 'SCF-DAT-004', ref: 'A.8.11' },
    { externalId: 'A.8.12', scfId: 'SCF-DAT-005', ref: 'A.8.12' },
    { externalId: 'A.8.13', scfId: 'SCF-BCM-003', ref: 'A.8.13' },
    { externalId: 'A.8.14', scfId: 'SCF-OPS-011', ref: 'A.8.14' },
    { externalId: 'A.8.15', scfId: 'SCF-OPS-006', ref: 'A.8.15' },
    { externalId: 'A.8.16', scfId: 'SCF-OPS-007', ref: 'A.8.16' },
    { externalId: 'A.8.17', scfId: 'SCF-OPS-008', ref: 'A.8.17' },
    { externalId: 'A.8.18', scfId: 'SCF-OPS-009', ref: 'A.8.18' },
    { externalId: 'A.8.19', scfId: 'SCF-OPS-010', ref: 'A.8.19' },
    { externalId: 'A.8.20', scfId: 'SCF-NET-001', ref: 'A.8.20' },
    { externalId: 'A.8.21', scfId: 'SCF-NET-002', ref: 'A.8.21' },
    { externalId: 'A.8.22', scfId: 'SCF-NET-003', ref: 'A.8.22' },
    { externalId: 'A.8.23', scfId: 'SCF-NET-004', ref: 'A.8.23' },
    { externalId: 'A.8.24', scfId: 'SCF-NET-005', ref: 'A.8.24' },
    { externalId: 'A.8.25', scfId: 'SCF-DEV-001', ref: 'A.8.25' },
    { externalId: 'A.8.26', scfId: 'SCF-DEV-002', ref: 'A.8.26' },
    { externalId: 'A.8.27', scfId: 'SCF-DEV-003', ref: 'A.8.27' },
    { externalId: 'A.8.28', scfId: 'SCF-DEV-004', ref: 'A.8.28' },
    { externalId: 'A.8.29', scfId: 'SCF-DEV-005', ref: 'A.8.29' },
    { externalId: 'A.8.30', scfId: 'SCF-DEV-006', ref: 'A.8.30' },
    { externalId: 'A.8.31', scfId: 'SCF-DEV-007', ref: 'A.8.31' },
    { externalId: 'A.8.32', scfId: 'SCF-DEV-008', ref: 'A.8.32' },
    { externalId: 'A.8.33', scfId: 'SCF-DEV-009', ref: 'A.8.33' },
    { externalId: 'A.8.34', scfId: 'SCF-DEV-010', ref: 'A.8.34' },
  ],
};

module.exports = {
  FRAMEWORK_ISO27002,
};
